import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "bullitt-time-results/templates/event/classgroup.hbs" })